export const chatsRoutes = {
  list: "",
  details: ":id",
} as const;
